import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

export const cn = (...inputs) => twMerge(clsx(inputs));

export const formatNumber = (value, options = {}) => {
  if (value === null || value === undefined || value === '') return '—';
  const number = Number(value);
  if (!Number.isFinite(number)) return '—';
  return new Intl.NumberFormat('en-IN', options).format(number);
};

export const formatDateTime = (value) => {
  if (!value) return 'Not recorded';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'Not recorded';
  return new Intl.DateTimeFormat('en-IN', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(date);
};

export const formatRelativeAge = (seconds) => {
  if (seconds === null || seconds === undefined) return 'Freshness unavailable';
  if (seconds < 60) return 'Updated just now';
  if (seconds < 3600) return `Updated ${Math.floor(seconds / 60)} min ago`;
  if (seconds < 86400) return `Updated ${Math.floor(seconds / 3600)} hr ago`;
  return `Updated ${Math.floor(seconds / 86400)} day${seconds < 172800 ? '' : 's'} ago`;
};

export const titleCase = (value = '') => value
  .replace(/_/g, ' ')
  .replace(/\b\w/g, (character) => character.toUpperCase());
